/* eslint-disable jsx-a11y/control-has-associated-label */
import PortalModalAccess from 'components/atoms/portal_modal_access';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { PortalsManagerState, PortalsTypes } from 'store/modules/portals_manager_store/types';
import moment from 'moment';
import Loader from 'components/atoms/loader';
import { TypesPortalsOption, TypesPortalsOptions } from 'services/types_portals';
import PortalDeleteModal from 'components/atoms/portal_delete_modal';
import createTrack from 'services/actions/tracker_actions';

const PortalsList = () => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showModalDelete, setShowModalDelete] = useState<boolean>(false);
  const [action, setAction] = useState<string>('');
  const [selectedPortal, setSelectedPortal] = useState<PortalsTypes | null>(null);

  const { portals_manager, request } = useSelector<ApplicationState, PortalsManagerState>(
    (state) => state.session.portals_manager,
  );

  const handleDelete = (portal: PortalsTypes) => {
    setShowModalDelete(true);
    setSelectedPortal(portal);
  };

  const handleClick = (portal: PortalsTypes, actionType: string) => {
    setShowModal(true);
    setSelectedPortal(portal);
    setAction(actionType);
  };

  const getPortalStatus = (expirationDate?: string | null): string => {
    if (!expirationDate) return '-';

    const today = moment();
    const expDate = moment(expirationDate, 'YYYY-MM-DD');
    const diffDays = expDate.diff(today, 'days');

    switch (true) {
      case expDate.isBefore(today, 'day'):
        return 'VENCIDO';
      case diffDays <= 3:
        return 'A VENCER';
      default:
        return 'ATIVO';
    }
  };

  const getPortalTypeLabel = (category_id: number | undefined): string => {
    const foundOption: TypesPortalsOption | undefined = TypesPortalsOptions.find(
      (option) => option.value === category_id,
    );
    return foundOption ? foundOption.label : '-';
  };

  return (
    <div className="card mt-4">
      <div className="card-body p-0">
        {request?.get_portals?.loading ? (
          <div>
            <Loader />
          </div>
        ) : portals_manager?.length === 0 ? (
          <div className="text-center py-5">
            <h5 className="mb-3">Você ainda não cadastrou nenhum portal!</h5>
            <p className="text-muted mb-4">
              Comece agora e mantenha seus portais organizados em um só lugar. É rápido e fácil!
            </p>
          </div>
        ) : (
          <table className="table table-card-responsive mb-0">
            <thead className="thead-light">
              <tr>
                <th>Portal</th>
                <th>Link</th>
                <th>Status</th>
                <th>Tipo</th>
                <th>Criado por</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {portals_manager?.map((portal) => {
                const portalStatus = getPortalStatus(portal?.login_expiration_date);
                const statusClass =
                  {
                    ATIVO: 'badge-success',
                    VENCIDO: 'badge-danger',
                    'A VENCER': 'badge-warning',
                  }[portalStatus] || 'badge-secondary';

                return (
                  <tr key={portal.id}>
                    <td className="align-middle">{portal.name}</td>
                    <td className="align-middle text-break w-25">
                      <a
                        href={portal.url.startsWith('http') ? portal.url : `https://${portal.url}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {portal.url}
                      </a>
                    </td>
                    <td className="align-middle">
                      <span className={`badge ${statusClass}`}>{portalStatus}</span>
                    </td>
                    <td className="align-middle">{getPortalTypeLabel(portal.category_id)}</td>
                    <td className="align-middle">
                      {portal.user_name}
                      <br />
                      <small>{moment(portal.created_at).format('DD/MM/YYYY HH:mm')}</small>
                    </td>
                    <td className="align-middle">
                      <button
                        type="button"
                        className="btn p-0 m-0"
                        onClick={() => handleClick(portal, 'edit')}
                      >
                        <i className="material-icons text-primary">edit_note</i>
                      </button>
                      <button
                        type="button"
                        className="btn p-0 my-0 mx-2"
                        onClick={() => {
                          handleClick(portal, 'view');
                          createTrack('Gerenciar Portais - Visualizou um acesso salvo');
                        }}
                      >
                        <i className="material-icons text-primary">visibility</i>
                      </button>
                      <button
                        type="button"
                        className="btn p-0 m-0"
                        onClick={() => handleDelete(portal)}
                      >
                        <i className="material-icons text-danger">delete</i>
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}

        <PortalModalAccess
          showModal={showModal}
          setShowModal={setShowModal}
          action={action}
          setAction={setAction}
          portal={selectedPortal}
        />
        <PortalDeleteModal
          showModal={showModalDelete}
          setShowModalDelete={setShowModalDelete}
          id={selectedPortal?.id}
          name={selectedPortal?.name}
        />
      </div>
    </div>
  );
};
export default PortalsList;
